var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.81149 12.1368H5.24668L5.24639 6.97058C5.24639 3.36242 8.19846 0.410278 11.8067 0.410278H17.9568C21.565 0.410278 24.5171 3.36235 24.5171 6.97058V12.1366L25.952 12.1369C27.7561 12.1369 29.2322 13.613 29.2322 15.4171V32.3095C29.2322 34.1136 27.7561 35.5896 25.952 35.5896H3.8115C2.00739 35.5896 0.531349 34.1136 0.531349 32.3095V15.4171C0.531349 13.613 2.00739 12.1372 3.8115 12.1372L3.81149 12.1368ZM13.2417 29.5623H16.5219V23.8223H13.2417V29.5623ZM8.52646 12.1368H21.2368V6.97058C21.2368 5.16646 19.7607 3.69043 17.9566 3.69043H11.8065C10.0023 3.69043 8.52631 5.16646 8.52631 6.97058L8.52646 12.1368Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLock);
export default __webpack_public_path__ + "static/media/login-lock.635aacbf297ecab98438132caef1405e.svg";
export { ForwardRef as ReactComponent };